import swal from 'sweetalert';
import {ts} from 'src/utils/translate';
import {
  toastError,
  toastInfoSingle,
  toastSuccess
} from "src/utils/controllerAdapterForOfferPage";

export const customHeaderKeyDown = (
    event,
    customSection,
    projectId,
    setCustomSectionButtonPressed,
    setConfirmedHeader,
    setNewTable,
    modifySection,
    tableId,
    setModifySection,
    setCurrentRowInEditing
) => {
    if (event.key === "Enter") {
        confirmCustomHeader(
            customSection,
            projectId,
            setCustomSectionButtonPressed,
            setConfirmedHeader,
            setNewTable,
            modifySection,
            tableId,
            setModifySection
        );
    } else if (event.key === "Escape") {
        setCustomSectionButtonPressed(false);
        setConfirmedHeader(false);
        setModifySection(false);
        setCurrentRowInEditing({});
    }
};

export const deleteCustomHeader = (sectionId, deleteSection) => {
    swal(
        {
            title: ts('warning'),
            text:
                ts('q_delete_request', 'Confirm deleting section by clicking OK button below'),
            showCancelButton: true,
            closeOnConfirm: false,
            animation: "slide-from-top",
            inputPlaceholder: "",
            customClass: {
                confirmButton: "delete-confirm-button-class",
                cancelButton: "delete-cancel-button-class",
            },
        }
    ).then(inputValue => {
        if (inputValue === false) return false;

        let data = {
            section_id: sectionId
        };

        deleteSection(data).then(
            response => {
                swal.close();

                toastSuccess(response.message);
            },
            response => {
                if (response.responseJSON && response.responseJSON.message) {
                    toastError(response.responseJSON.message);
                }
            }
        );
    });
};

export const confirmCustomHeader = (
    name,
    projectId,
    setCustomSectionButtonPressed,
    setConfirmedHeader,
    setNewTable,
    modifySection,
    tableId,
    setModifySection,
    confirmSection,
    editSection
) => {
    const newName = name.trim();
    let data = {};

    if (newName.length === 0) {
        toastInfoSingle(ts("q_sectionnameplease", "Please enter a name for the section"));
    } else {
        if (modifySection) {
            data = {
                section_id: tableId,
                section_name: newName,
            };
        } else {
            data = {
                project_id: projectId,
                section_name: newName,
            };
        }

        if (modifySection) {
            editSection(data).then(
                response => {
                    toastSuccess(response.message);

                    setModifySection(false);
                    setConfirmedHeader(true);
                },
                response => {
                    setCustomSectionButtonPressed(false);

                    if (response.responseJSON && response.responseJSON.message) {
                        toastError(response.responseJSON.message);
                    }
                }
            );
        } else {
            confirmSection(data).then(
                response => {
                    const newId = response.id;
                    toastSuccess(response.message);

                    setNewTable({
                        id: newId,
                        name: newName,
                        entitytype: "sectiontable",
                    });

                    setConfirmedHeader(true);

                    setCustomSectionButtonPressed(false);
                },
                response => {
                    setCustomSectionButtonPressed(false);

                    if (response.responseJSON && response.responseJSON.message) {
                        toastError(response.responseJSON.message);
                    }
                }
            );
        }
    }
};